import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { IAuthenticator } from './IAuthenticator';
import { ILoginModel } from "./ILoginModel";
import { ILoginJWTModel } from "./ILoginJWTModel";
import { ILoginOauthModel } from "./ILoginOauthModel";
import { ILoginValidationModel } from "./ILoginValidationModel";
import { IRefreshTokenModel } from "./IRefreshTokenModel";
import { ITokenResultModel } from "./ITokenResultModel";
import { LoginResult } from "./LoginResult";

interface IRemoveTokenResult {
    res: boolean;
}

class Authenticator implements IAuthenticator {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    login(model: ILoginModel): Promise<LoginResult> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/v3/auth/login',
            method: HttpMethod.POST
        }, model);

        return new Promise<LoginResult>((resolve, reject) => {
            this.manager
                .get<LoginResult>(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    resolve(new LoginResult());
                })
        });
    }
    loginWithOauth(model: ILoginOauthModel): Promise<LoginResult> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/v3/auth/oauth',
            method: HttpMethod.POST
        }, model);

        return new Promise<LoginResult>((resolve, reject) => {
            this.manager
                .get<LoginResult>(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    resolve(new LoginResult());
                })
        });
    }

    loginWithJWT(model: ILoginJWTModel): Promise<LoginResult> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/v3/auth/jwt',
            method: HttpMethod.POST
        }, model);

        return new Promise<LoginResult>((resolve, reject) => {
            this.manager
                .get<LoginResult>(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    resolve(new LoginResult());
                })
        });
    }

    loginWithValidationModel(model: ILoginValidationModel): Promise<LoginResult> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/v3/auth/validation-token',
            method: HttpMethod.POST
        }, model);

        return new Promise<LoginResult>((resolve, reject) => {
            this.manager
                .get<LoginResult>(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    resolve(new LoginResult());
                })
        });
    }

    createToken(secret: string): Promise<ITokenResultModel | null> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/v3/auth/token',
            method: HttpMethod.PUT
        }, { secret: secret });

        return new Promise<ITokenResultModel | null>((resolve, reject) => {
            this.manager
                .get<ITokenResultModel>(request)
                .then((res) => {
                    if (res.auth == null) {
                        resolve(null);
                    } else {
                        resolve(res);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }
    refreshToken(model: IRefreshTokenModel): Promise<ILoginOauthModel | null> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/v3/auth/token',
            method: HttpMethod.POST
        }, model);

        return new Promise<ILoginOauthModel | null>((resolve, reject) => {
            this.manager
                .get<ILoginOauthModel>(request)
                .then((res) => {
                    if (res.token === null) {
                        resolve(null);
                    } else {
                        resolve(res);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve({
                        token: ''
                    });
                })
        });
    }
    removeTokenAccess(): Promise<boolean> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/v3/auth/token',
            method: HttpMethod.DELETE
        });

        return new Promise<boolean>((resolve, reject) => {
            this.manager
                .get<IRemoveTokenResult>(request)
                .then((res) => {
                    resolve(res.res ?? false);
                })
                .catch((err) => {
                    console.log(err);
                    resolve(false);
                })
        });
    }

}

export default (framework: IFramework) => {
    framework.registerTransient<IAuthenticator>('IAuthenticator', (frm) => {
        return new Authenticator(frm);
    });
}